/**
 * PriceTicker — HD (Runde 6)
 *
 * Dezenter Preisticker (HNT / IOT / MOBILE) im AppShell-Header.
 *
 * Entscheidungen:
 * - Nur Desktop (per CSS ab 1024px sichtbar) und nur im eingeloggten
 *   AppShell-Bereich — auf oeffentlichen Seiten wird er nicht gerendert.
 * - Werte in USD bzw. der eingestellten Nutzerwaehrung (Backend rechnet um).
 * - NICHT klickbar (wie v1), rein informativ: role="status".
 * - Nutzt die bestehende Preis-Query useCryptoPrices — KEIN zusaetzliches
 *   Polling-Intervall, kein zweiter Endpunkt.
 *
 * Loest den fruheren, ueber der Topbar liegenden CryptoPriceStrip ab, der
 * eine eigene volle Leiste belegte.
 */
import { useTranslation } from 'react-i18next'
import { useCryptoPrices } from '../hooks/useCryptoPrices'
import { fmtPrice } from '../lib/fmt'

const TOKENS = ['hnt', 'iot', 'mobile'] as const

export function PriceTicker() {
  const { t } = useTranslation('shell')
  const { prices, currency, isLoading, isError } = useCryptoPrices()

  // Kein Platzhalter-Rauschen im Header: solange nichts geladen ist oder der
  // Endpunkt fehlschlaegt, bleibt der Ticker unsichtbar.
  if (isLoading || isError) return null
  if (TOKENS.every((token) => prices[token] == null)) return null

  return (
    <div
      className="price-ticker"
      role="status"
      aria-label={t('topbar.priceTicker.ariaLabel')}
      data-testid="price-ticker"
    >
      {TOKENS.map((token, idx) => (
        <span key={token} className="price-ticker__item" data-testid={`price-ticker-${token}`}>
          {idx > 0 && <span className="price-ticker__divider" aria-hidden="true">·</span>}
          <span className="price-ticker__symbol">{token.toUpperCase()}</span>
          <span className="price-ticker__value">{fmtPrice(prices[token], currency)}</span>
        </span>
      ))}
    </div>
  )
}

export default PriceTicker
